import React, { Component } from 'react';

import {connect} from "react-redux";
import Header from "./components/header";
import Footer from "./components/footer";
import { withRouter } from "react-router-dom";
import PageListen from "./components/pagelisten";
import * as wActs from "./actions/website-actions";
import * as sActs from "./actions/server-actions";
import {Helmet} from "react-helmet";
import { IntlProvider } from 'react-intl';
import BreadCrumbs from "./components/breadcrumbs"
import Warnings from "./components/warning";

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageType: props.pageType
    };
  }

  componentDidMount() {
    if(typeof window !== "undefined") {
      if(sActs.getServerCookie(this.props.Website.ServerParams.Cookies,"anon") === null) {
        wActs.setCookie("anon", this.props.Website.Request.AnonymousId, { path: "/", maxAge: 31557600, domain: "." + wActs.getSubdomain(window.location.hostname) });
      }
    }
  }

  componentDidUpdate() {

  }

  handleScroll(e) {

  }

  smallWidth() {
    if(typeof window !== "undefined") {
      if(window.innerWidth < 767) {
        //console.log("here");
        return true
      }
    } else {
      return false;
    }
    return false;
  }

  getTranslation(key) {
    return this.props.Website.Translations[key];
  }


  render() {
    //throw new Error("Error Dude");
    if(!this.props.SiteLoaded) {
      return (
      <div id={"loadingDiv"}>
        <img src="/imgs/loader.gif" width="100" height="100" alt={"Loading"}/>
      </div>
      );
    }



    let xDef = typeof window === "undefined" ? wActs.stripCulturePath(this.props.Website.ServerParams.Path) : wActs.stripCulturePath(window.location.pathname);
    xDef = wActs.getCultPathByLang(this.props.Website, wActs.defaultLang(this.props.Website)) + xDef.substr(1);





    let mob = this.props.Website.Device.IsMobileDevice;

    return (
      <div className="App" id={"mainApp"}>
        {this.props.Website.PageLoaded &&
          <Helmet>
            <title>{this.props.Website.Page.Title}</title>
            {!this.props.Website.Page.HideKeywords &&
            <meta name="keywords" content={this.props.Website.Page.Keywords} />
            }
            <meta name="description" content={this.props.Website.Page.Description} />
            {
              this.props.Website.Page.Properties.map((v,i) => {
                if(v.Name.startsWith("twitter:")) {
                  return <meta key={"set-" + i} name={v.Name} content={v.Content}/>;
                } else {
                  return <meta key={"set-" + i} property={v.Name} content={v.Content}/>;
                }
              })
            }
            {
              this.props.Website.Page.Icons.map((v,i) => {
                return <link key={"ico-" + i} rel={v.Rel} sizes={v.Sizes} type={v.Type} href={v.Href} />;
              })
            }
            {!wActs.isNullOrUndefined(this.props.Website.Page.References) &&
              this.props.Website.Page.References.filter((t) => { return t.Rel.toLowerCase() === "alternate" }).map((v, i) => {
                return <link key={"alt-" + i} rel={v.Rel} href={v.Href === "" ? "/" : v.Href} hrefLang={v.HrefLang} />;
              })
            }
            {!wActs.isNullOrUndefined(this.props.Website.Page.References) &&
              this.props.Website.Page.References.filter((t)=>{return t.Rel.toLowerCase() === "canonical"}).map((v,i) => {
                return <link key={"can-" + i} rel={v.Rel} href={v.Href} />;
              })
            }
            {this.props.Website.Page.NoIndex &&
            <meta name="robots" content="noindex"/>
            }
          </Helmet>
        }
        <IntlProvider locale={this.props.Website.TranslationsLocal} defaultlocale={'en'} messages={this.props.Website.Translations} >
            <div className="wrapper">
              {typeof window !== "undefined" && <PageListen/>}
              <Header/>
              <BreadCrumbs/>

              {this.props.children}

              <Footer/>
              <Warnings/>
            </div>
        </IntlProvider>
      </div>
    );
  }




}

function exportWithRouter() {
  if (typeof window !== "undefined") {
    return withRouter(connect(mapStateToProps)(App));
  } else {
    return connect(mapStateToProps)(App);
  }
}



const mapStateToProps = (state) => {
  return {
    SiteLoaded: state.Website.Loaded,
    Menu: state.Website.Menu,
    Settings: state.Website.Settings,
    Website: state.Website,
    PageMenu: state.Website.Page.Menu,
    Template: state.Website.Page.Template
  };
};



export default exportWithRouter(); //Added This To Support Pageless Once SSR Is Done.. Only Works Client Withrouter, And Without SSR
